import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarWrapper from './SidebarWrapper';
import { LayoutMainContainer } from './LayoutUI';
import ScrollableWrapper from '../components/ScrollableWrapper';
import { IS_SCREENSHOT_MODE } from '../config/constants';

interface IProps {
  children: ReactNode;
}

const SidebarLayout = ({ children }: IProps) => {
  if (IS_SCREENSHOT_MODE) {
    return <Outlet />;
  }

  return (
    <>
      <SidebarWrapper>{children}</SidebarWrapper>
      <ScrollableWrapper>
        <LayoutMainContainer>
          <Outlet />
        </LayoutMainContainer>
      </ScrollableWrapper>
    </>
  );
};

export default SidebarLayout;
